import { composeIO } from 'react-compose-io'
import { uploadPlanilhaRegularizacaoIO } from './UploadPlanilhaRegularizacao.IO'
import { UploadPlanilhaRegularizacaoView } from './UploadPlanilhaRegularizacao.View'

export const UploadPlanilhaRegularizacao = composeIO(UploadPlanilhaRegularizacaoView, uploadPlanilhaRegularizacaoIO)
